const platform = process.env.VUE_APP_PLATFORM || "pc";
const isBrowser = typeof window !== "undefined";
const userAgent = isBrowser ? window.navigator.userAgent : "";
const isMobileWeb = isBrowser && /Android|iPhone|iPad|Mobile/i.test(userAgent);
const isMpWebview = platform === "mp-webview";
const isMobile = isMpWebview || isMobileWeb;
const routerMode =
    process.env.VUE_APP_ROUTER_MODE || (isMpWebview ? "hash" : "history");
const realPayEnabled = process.env.VUE_APP_ENABLE_REAL_PAY !== "false";
const storageMode = isMpWebview ? "local" : "session";
const paymentMode = isMpWebview ? "mini" : "web";

export {
    platform,
    isBrowser,
    isMobile,
    isMobileWeb,
    isMpWebview,
    routerMode,
    realPayEnabled,
    storageMode,
    paymentMode,
};

export default {
    platform,
    isBrowser,
    isMobile,
    isMobileWeb,
    isMpWebview,
    routerMode,
    realPayEnabled,
    storageMode,
    paymentMode,
};
